<template>
  <div class="general-wrapper" v-if="client">
    <Header parent="clients_base">
      <template #title>
        <h4 class="qrw-heading-md">
          {{ client.name }}
        </h4>
      </template>

      <template #actions>
        <BaseButton @click="$router.push(`/clients_base/${client._id}/history`)" variant="secondary" size="md">
          {{ $t('worker_profile.orders_history') }}
        </BaseButton> 
      </template>
    </Header>

    <PageContainer>
      <div class="gap-row-sm">
        <div class="iqos-grid">
          <div class="iqos-column">
            <IQOS class="gap-row-xs" :title="$t('client_profile.general_title')">
              <p class="qrw-paragraph-md">
                <span class="v1-grey-7-color">
                  {{ $t("client_profile.phone") }}
                </span>
                <span class="v1-grey-10-color">{{ client.phone }}</span>
              </p>
              <p class="qrw-paragraph-md" v-if="client.address">
                <span class="v1-grey-7-color">
                  {{ $t("client_profile.address") }}
                </span>
                <span class="v1-grey-10-color">{{ client.address }}</span>
              </p>
            </IQOS>
          </div>
          <div class="iqos-column">
            <IQOS
              :enabled="collectBonusesOption"
              :title="$t('client_profile.bonuses_title')"
              :class="!collectBonusesOption ? 'iqos-transparent' : ''"
            >
              <p class="iqos-comment qrw-paragraph-md mt-16">
                {{ $t("client_profile.bonuses_desc") }}
              </p>

              <template #actions>
                <IQOSToggle v-model="collectBonusesOption" />
              </template>
            </IQOS>
            <IQOS
              :enabled="discount_active"
              :title="$t('client_profile.discount_title')"
              :class="discount_active ? '' : 'iqos-transparent'"
            >
              <BaseUnitInput
                unitPlaceholder="%"
                type="number"
                class="mt-16 w-100"
                fullWidth
                v-model.number="balance.discount"
                @blur="updateBalance"
                placeholder="0"
                :readonly="false"
                :valid="discount_active && balance.discount"
                v-if="discount_active"
              />
              <p class="iqos-comment qrw-paragraph-md mt-16">
                {{ $t("client_profile.discount_desc") }}
              </p>
              <template #actions>
                <IQOSToggle v-model="discountOption" />
              </template>
            </IQOS>
          </div>
        </div>
      

      <IQOS class="gap-row-xs" :title="$t('client_profile.summary_title')">
        <div class="profile-params">
          <div class="profile-param">
            <div class="param-title qrw-label-sm">
              {{ $t("client_profile.summary_average") }}
            </div>
            <div class="param-value qrw-heading-md">
              {{ summary.average }}{{ currency.symbol }}
            </div>
          </div>
          <div class="profile-param">
            <div class="param-title qrw-label-sm">
              {{ $t("client_profile.summary_orders") }}
            </div>
            <div class="param-value qrw-heading-md">
              {{ summary.orders }}
            </div>
          </div>
          <div class="profile-param">
            <div class="param-title qrw-label-sm">
              {{ $t("client_profile.summary_total") }}
            </div>
            <div class="param-value qrw-heading-md">
              {{ summary.total }}{{ currency.symbol }}
            </div>
          </div>
          <div class="profile-param">
            <div class="param-title qrw-label-sm">
              {{ $t("client_profile.summary_bonuses") }}
            </div>
            <div class="param-value qrw-heading-md">
              {{ summary.bonuses }}{{ currency.symbol }}
            </div>
          </div>
          <div class="profile-param">
            <div class="param-title qrw-label-sm">
              {{ $t("client_profile.summary_period") }}
            </div>
            <div class="param-value qrw-heading-md">
              {{ summary.period }} дн.
            </div>
          </div>
        </div>
        <BaseDivider color="v1-grey-6" />
        <div class="top-table gap-row-1xs">
          <p class="iqos-comment qrw-paragraph-md">
            {{ $t("client_profile.summary_top_dishes") }}
          </p>
          <div
            class="qrw-paragraph-md"
            v-for="(item, index) in summary.top_dishes"
            :key="index"
          >
            {{ index + 1 }}. {{ item }}
          </div>
        </div>
      </IQOS>

      </div>
    </PageContainer>
  </div>
</template>

<script>
import StatsAPI from "@/api/stats";
import ClientsAPI from "@/api/clients";

export default {
  data() {
    return {
      client: { name: 1, phone: "+3805050505", address: 1 },
      summary: null,
      balance: null,

      discount_active: false,
    };
  },
  methods: {
    fetchProfile() {
      StatsAPI.getClientProfile(this.cafe._id, this.$route.params.id).then(
        (data) => {
          this.client = data.client;
          this.balance = data.balance;
          this.summary = data.summary;

          this.discount_active = this.balance.discount > 0;
        }
      );
    },
    updateBalance() {
      if (!this.discount_active) {
        this.$set(this.balance, "discount", 0);
      } else {
        if (!this.balance.discount) {
          return;
        }
      }

      ClientsAPI.updateClientBalance(this.balance._id, {
        discount: this.balance.discount,
        collect_bonuses: this.balance.collect_bonuses,
      })
        .then((ok) => {
          this.$store.dispatch("auditlog/write", {
            type: "change_client_discounts",
            payload: {
              client_id: this.client._id,
              client_name: this.client.name,
              client_phone: this.client.phone,
              discount: this.balance.discount,
              collect_bonuses: this.balance.collect_bonuses,
            },
          });
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    currency() {
      return this.$store.state.currency;
    },
    collectBonusesOption: {
      get() {
        return this.balance.collect_bonuses;
      },

      set(v) {
        this.$set(this.balance, "collect_bonuses", v);
        this.updateBalance();
      },
    },
    discountOption: {
      get() {
        return this.discount_active;
      },

      set(v) {
        this.discount_active = v;

        if (!v) {
          this.$set(this.balance, "discount", 0);
        }
        this.updateBalance();
      },
    },
  },
  mounted() {
    this.fetchProfile();
  },
};
</script>

<style scoped>
.profile-params {
  display: flex;
  justify-content: space-between;
}

.profile-param {
  display: block;
  text-align: left;
}

.param-title {
  color: #908f8d;
}

.param-value {
  line-height: normal;
}
</style>